export default __webpack_public_path__ + "static/gatsby_git_repo-e492d1707b37208a4b46e45f3137cc4f.png";